import React from 'react';

const Footer = () => {
    return (
      <footer className="app-footer">
        <span className="d-inline-block">Copyright RusHolts &copy; 2019. All rights reserved.</span>
        
      </footer>
    );
  }
;

export default Footer;
